import { render } from "./QuizNavbar.vue?vue&type=template&id=126c8bcf&scoped=true"
import script from "./QuizNavbar.vue?vue&type=script&lang=js"
export * from "./QuizNavbar.vue?vue&type=script&lang=js"

import "./QuizNavbar.vue?vue&type=style&index=0&id=126c8bcf&scoped=true&lang=css"

import exportComponent from "D:\\Mindscan\\online-quiz-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-126c8bcf"]])

export default __exports__